/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { DividerNew, Icon, Placeholder, Text, TextField } from 'sarsaparilla';

import { type GroupedFacilities } from './SitePassFacilities';

import './FacilitiesList.scss';

export default function FacilitiesList({
    facilitiesList,
    onFilterFacilities,
}: {
    facilitiesList: GroupedFacilities[] | null;
    onFilterFacilities: (searchTerm: string) => void;
}) {
    if (!facilitiesList || facilitiesList.length === 0) {
        return (
            <>
                <Placeholder width="343px" height="40px" />
                <Placeholder width="343px" height="670px" className="mt-2" />
            </>
        );
    }

    return (
        <>
            <TextField
                iconElement={<Icon iconName="search" />}
                id="facility-filter"
                label="Filter Facilities"
                placeholder="Search by name, location, or state"
                hasClearButton
                onChange={(e) => {
                    onFilterFacilities(e.target.value);
                }}
            />
            <div className="facilities-list-box">
                {facilitiesList.map((group: GroupedFacilities) => {
                    return (
                        <div key={group.state} className="state-group">
                            <Text fontWeight="semibold" size="md">
                                {group.state.toUpperCase()}
                            </Text>
                            <DividerNew className="mt-1" />
                            <ul className="facility-list">
                                {group.facilities.map((facility) => (
                                    <li key={facility.id} className="facility-item">
                                        <a
                                            className="facility-link"
                                            href={`/sitepass/${facility.id}`}
                                            data-ga-tracking-id="221040226925"
                                        >
                                            {facility.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

// cspell:ignore sitepass
